import React, { useCallback, useState } from 'react'

import { Field, connect } from 'formik'
import { FormValues } from 'donate/types'
import { I18nHtml, Modal, postMessageScrollTop } from 'shared'
import { PlatformNewsletterCheckboxFieldProps } from './types'

export const PlatformNewsletterCheckbox = connect<{}, FormValues>(({ formik }) => {
  if (!formik.values._show_platform_subscription) return null

  const [showModal, setShowModal] = useState(false)
  const hideModal = useCallback(() => {
    setShowModal(false)
  }, [])
  const openModal = useCallback((event?: React.MouseEvent | React.KeyboardEvent) => {
    // Prevent the checkbox to (un)tick.
    if (event) event.preventDefault()

    setShowModal(true)
  }, [])

  return (
    <>
      <Field name="newsletter">
        {({ field }: PlatformNewsletterCheckboxFieldProps) => (
          <div className="platform-donations-new-subscribe-to-platform-newsletter mb-3">
            <label className="generic-custom-radio-field w-full mb-0" htmlFor="subscribeToPlatformNewsletter">
              <input type="checkbox" {...field} id="subscribeToPlatformNewsletter" />

              <span className="generic-custom-radio" />
              <div>
                {i18n.t('shared.newsletter_consent.platform.label_prefix.donation_form')}{' '}
                <span
                  className="simulated-link larger-click-area"
                  onClick={openModal}
                  onKeyPress={openModal}
                  tabIndex={0}
                  role="button"
                >
                  {i18n.t('shared.newsletter_consent.platform.consent_modal_opener_label')}
                </span>{' '}
                {i18n.t('shared.newsletter_consent.platform.label_suffix')}
              </div>
            </label>
          </div>
        )}
      </Field>
      <Modal
        id="betterplace-newsletter-subscription-legal-modal"
        onHide={hideModal}
        onShow={postMessageScrollTop}
        show={showModal}
        header={i18n.t('shared.newsletter_consent.platform.legal_modal.heading')}
        footer={
          <button className="my-1 btn btn-primary" onClick={hideModal} type="button">
            {i18n.t('misc.close')}
          </button>
        }
      >
        <I18nHtml i18nKey="shared.newsletter_consent.platform.legal_modal.content" />
      </Modal>
    </>
  )
})
